module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Drop elements here":"Drop elements here"},"de":{"Drop elements here":"Elemente hierher ziehen"}}')
  delete Component.options._Ctor
}
